import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {CheckIcon, ThinArrowLeft, TomansIcon} from "../../../components/icons/material-icons";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

export const StudentsStoreInvoiceScreen = () => {
    const {invoiceNd} = useParams();
    let navigate = useNavigate();
    const [data, setData] = useState({
        loaded: false,
        price: 0,
        url: '#',
        createdAt: '2000-01-01 00:00:00',
        isPaid: false,
        paidAt: '2000-01-01 00:00:00',
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/store/get-invoice',
            {nd: invoiceNd as string},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                price: number,
                pay: string,
                createdAt: string,
                isPaid: boolean,
                paidAt: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    else if (d.reason === 'not-found') {
                        ShowSnackbar('فاکتور موردنظر یافت نشد.', 'باشه', 5000);
                        navigate('/students/store', {replace: true});
                    }
                    return;
                }
                setData({
                    loaded: true,
                    createdAt: d.createdAt,
                    price: d.price,
                    url: d.pay,
                    isPaid: d.isPaid,
                    paidAt: d.paidAt,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "فاکتور فروشگاه | نهال";
        fetchData();
    }, []);
    const launchPayScreen = () => {
        const url = data.url;
        ShowProgressLoading();
        window.location.href = url;
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'بوفه', url: '/students/store'},
                {title: 'فاکتور شارژ', url: `/students/store/invoice/${invoiceNd}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>فاکتور شارژ بوفه</b>
                                    </div>
                                    {
                                        !data.isPaid ?
                                            <>
                                                <div className="tuition-invoice-preview">
                                                    <i>
                                                        <span>{StringDigitsConvertToPersian(CurrencyFormat(data.price))}</span>
                                                        <TomansIcon/>
                                                    </i>
                                                </div>
                                                <div style={{height: 30}}/>
                                            </> :
                                            <>
                                                <div className="tuition-invoice-checkmark">
                                                    <i><CheckIcon/></i>
                                                    <b>پرداخت موفق</b>
                                                </div>
                                                <div style={{height: 30}}/>
                                            </>
                                    }
                                    <div className="info-tile">
                                        <b>کد فاکتور:</b>
                                        <span>{invoiceNd?.toUpperCase()}</span>
                                    </div>
                                    {
                                        data.isPaid ?
                                            <div className="info-tile">
                                                <b>مبلغ:</b>
                                                <span>{StringDigitsConvertToPersian(CurrencyFormat(data.price))} تومان</span>
                                            </div> : null
                                    }
                                    <div className="info-tile">
                                        <b>موضوع فاکتور:</b>
                                        <span>شارژ حساب بوفه</span>
                                    </div>
                                    <div className="info-tile">
                                        <b>تاریخ ایجاد:</b>
                                        <span>{StringDigitsConvertToPersian(GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</span>
                                    </div>
                                    {
                                        data.isPaid ?
                                            <div className="info-tile">
                                                <b>تاریخ پرداخت:</b>
                                                <span>{StringDigitsConvertToPersian(GregorianToPersian(data.paidAt.split(' ')[0]).replaceAll('-', '/'))}</span>
                                            </div> : null
                                    }
                                    <div className="info-tile">
                                        <b>نحوه پرداخت:</b>
                                        <span>پرداخت آنلاین</span>
                                    </div>
                                    {
                                        !data.isPaid ?
                                            <>
                                                <div style={{height: 20}}/>
                                                <div className="d-flex justify-content-end align-items-center">
                                                    <button className="btn-pay" onClick={launchPayScreen}>
                                                        <b>پرداخت آنلاین</b>
                                                        <ThinArrowLeft/>
                                                    </button>
                                                </div>
                                            </> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};